"use strict"

import React, { useEffect, useState } from "react"

import { getTableTranslations } from "../../../tables/utils"
import EditSingleFileModal from "../../../shared_components/administration/file_uploads/EditSingleFileModal"
import { table_name } from "./FileUploadScreen"

export default function FileUploadTable({
  selected_file_id,
  setFileSelection,
  user_can_edit,
  tableReload,
  intl,
}) {
  const [showModal, setShowModal] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  useEffect(() => {
    if (selected_file_id) {
      setSelectedId(selected_file_id)
      setShowModal(true)
    }
  }, [selected_file_id])

  const translation_mapping = {
    name: { id: "general.name", default: "Name" },
    filename: { id: "general.filename", default: "File Name" },
    date_updated: { id: "general.updated.on", default: "Updated On" },
    updated_by: { id: "general.updated.by", default: "Updated By" },
    date_created: { id: "general.created.on", default: "Created On" },
    created_by: { id: "general.created.by", default: "Created By" },
    transformation_state: { id: "general.status", default: "Status" },
    filetype: { id: "general.type", default: "Type" },
    size: { id: "general.size", default: "Size" },
    locked_for_retransformation: { id: "general.locked", default: "Locked" },
    id: { id: "administration.edit-file", default: "Edit File" },
  }

  $(`#${table_name}`).on("load-success.bs.table expand-row.bs.table", () => {
    getTableTranslations(intl, table_name, translation_mapping)
  })

  getTableTranslations(intl, table_name, translation_mapping)

  return (
    <>
      {showModal && user_can_edit && (
        <EditSingleFileModal
          intl={intl}
          file_id={selectedId}
          show={showModal}
          tableReload={tableReload}
          onHide={() => {
            setFileSelection(null)
            setShowModal(false)
          }}
        />
      )}
      <table id={table_name} className={table_name} style={{ marginTop: "5px" }} />
    </>
  )
}
